module.exports = __webpack_public_path__ + "static/img/long_figure.6bb2354.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/long_figure.jpg
// module id = fRy9
// module chunks = 1